import CollaborationRoom from '../components/CollaborationRoom';

export default function TeamPage() {
  return (
    <div className="h-full">
      <CollaborationRoom />
    </div>
  );
}
